import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/nota/devolucao';

export default {
  cadastrar: async (notaDevolucao) => financeiroApi.post(`${PATH}`, notaDevolucao),
  validarPendencias: async (notaDevolucao) => financeiroApi.post(`${PATH}/pendencias`, notaDevolucao),
  validarPendenciasReenvio: async (uuid) => financeiroApi.post(`${PATH}/pendencias/reenvio?uuid=${uuid}`),
  buscar: async (id) => financeiroApi.get(`${PATH}/${id}`),
  reenviar: async (uuid) => financeiroApi.post(`${PATH}/reenviar?uuid=${uuid}`),
  cancelar: async (uuid) => financeiroApi.post(`${PATH}/cancelar?uuid=${uuid}`),
  atualizarHomol: async (situacao) => financeiroApi.get(`${PATH}/atualizar/homol/${situacao}`),
};
